import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import ProblemSolution from './components/ProblemSolution';
import Vision from './components/Vision';
import WaitlistForm from './components/WaitlistForm';
import Footer from './components/Footer';
import FAQSection from './components/faq';

export default function App() {
  const [preselectedRole, setPreselectedRole] = useState(null);

  const handleSelectRole = (role) => {
    setPreselectedRole(role);
    setTimeout(() => {
      document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  return (
    <div>
      <Navbar />
      <Hero onSelectRole={handleSelectRole} />
      <HowItWorks />
      <ProblemSolution />
      <Vision />
      <WaitlistForm preselectedRole={preselectedRole} />
      <FAQSection/>
      <Footer />
    </div>
  );
}
